/**
 * GoodLeap logo for admin error emails.
 * Hosted PNG — Outlook does not render SVG / data: URIs reliably.
 * File: public/email/goodleap_logo.png (publish frontend to update).
 */
export const ADMIN_ERROR_EMAIL_LOGO_SRC =
  "https://www.goodleap.dev/email/goodleap_logo.png";

/** Native asset is 177×56; keep aspect for email clients. */
export const ADMIN_ERROR_EMAIL_LOGO_WIDTH = 177;
export const ADMIN_ERROR_EMAIL_LOGO_HEIGHT = 56;
